import { CampaignSubSource } from 'utils/constants/campaign';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type IsVisible = boolean;

export interface RemainderBudget {
    apiSource: CampaignSubSource;
    remainder: number;
    totalAmount: number;
}

// ----------------------- actions -------------------------------------
const SET_VISIBLE_REMAINDER_BUDGETS = 'SET_VISIBLE_REMAINDER_BUDGETS';
const SET_DATA_REMAINDER_BUDGETS = 'SET_DATA_REMAINDER_BUDGETS';

interface PayloadTypes {
    [SET_VISIBLE_REMAINDER_BUDGETS]: IsVisible;
    [SET_DATA_REMAINDER_BUDGETS]: RemainderBudget[];
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setVisibleRemainderBudgets = ActionCreator(SET_VISIBLE_REMAINDER_BUDGETS);
export const setDataRemainderBudgets = ActionCreator(SET_DATA_REMAINDER_BUDGETS);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface RemainderBudgetsState {
    isVisible: IsVisible;
    remainderBudgetsData: RemainderBudget[];
}

const REMAINDER_BUDGETS_INITIAL_STATE: RemainderBudgetsState = {
    isVisible: false,
    remainderBudgetsData: [],
};

export default createReducer<RemainderBudgetsState, PayloadTypes>(REMAINDER_BUDGETS_INITIAL_STATE, {
    [SET_VISIBLE_REMAINDER_BUDGETS]: (state, { payload }) => ({
        ...state,
        isVisible: payload,
    }),
    [SET_DATA_REMAINDER_BUDGETS]: (state, { payload }) => ({
        ...state,
        remainderBudgetsData: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
